import type { OwaDate, GlobalCalendarLocale } from "owa-datetime";
import { localizedFormatter } from "./localizedFormatter";

/**
 * Gets the short hour format, from the user's settings, according to these rules:
 *
 * - Respects 12/24 hour settings
 * - Respects relative AM/PM position
 * - No leading zero
 * - AM/PM: only in 12-hour formats
 *
 * In jsMVVM it used to shows minutes if they were not zero, but the format was only
 * effectively used in places where an hour without minutes was used (calendar grid, for example).
 * So from now on, short hour will NOT produce minutes.
 */
export function getShortHourFormat(_dateFormat: string, timeFormat: string): string {
    let format = timeFormat
        .replace(/'[^']*'|[^Hht]/g, "") // remove chars inside quotes and chars other than H, h and t outside quotes; keep order and 12/24 hour format.
        .replace("HH", "H") // convert leading zeros to non-leading zeros
        .replace("hh", "h");
    
    // add a space between hour and meridiem; it will only be there in 12-hour formats.
    const meridiemIndex = format.search(/(tt)/);
    if (meridiemIndex >= 0) {
        format = format.replace(/(tt)/, meridiemIndex == 0 ? "$1 " : " $1");
    }
    
    // format comes out as either H, h tt or tt h.
    return format;
}

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string = 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
localizedFormatter(getShortHourFormat);
export default defaultExport;
